const ReservationStatusTypes = {
  /** Status for newly created unpaid reservations */
  NEW: 'NEW',
  /** Reservation gets PENDING status after user having paid for the reservation or after adding a resident manually by a property manager */
  PENDING: 'PENDING',
  CANCELLED_WITH_FEE: 'CANCELLED_WITH_FEE',
  CANCELLED_WITHOUT_FEE: 'CANCELLED_WITHOUT_FEE',
  MOVED_IN: 'MOVED_IN',
  PAYPAGE: 'PAYPAGE',
  MOVED_OUT: 'MOVED_OUT',
  _Values: () =>
    Object.keys(ReservationStatusTypes)
      .filter(key => typeof ReservationStatusTypes[key] !== 'function')
      .map(key => ReservationStatusTypes[key]),
};

const ResidentStatus = {
  NON_RESIDENT: 'NON_RESIDENT',
  PENDING: 'Pending',
  FUTURE: 'Future',
  APPLICANT: 'Applicant',
  PAST: 'Past',
  PENDING_INVITE: 'PENDING_INVITE',
  _Values: () =>
    Object.keys(ResidentStatus)
      .filter(key => typeof ResidentStatus[key] !== 'function')
      .map(key => ResidentStatus[key]),
};

const ReservationType = {
  SELF: 'SELF',
  INVITE_SELF: 'INVITE_SELF',
  INVITE: 'INVITE',
  _Values: () =>
    Object.keys(ReservationType)
      .filter(key => typeof ReservationType[key] !== 'function')
      .map(key => ReservationType[key]),
};

const ServiceRequestStatus = {
  CALL: 'CALL',
  WEB: 'WEB',
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  REQUEST_REASSIGNMENT: 'REQUEST_REASSIGNMENT',
  SCHEDULED: 'SCHEDULED',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  SUBMITTED: 'SUBMITTED',
  FAILED: 'FAILED',
  _Values: () =>
    Object.keys(ServiceRequestStatus)
      .filter(key => typeof ServiceRequestStatus[key] !== 'function')
      .map(key => ServiceRequestStatus[key]),
};

module.exports = {
  ReservationStatusTypes,
  ResidentStatus,
  ReservationType,
  ServiceRequestStatus,
};
